// 桌機滑鼠/觸控板的預設手勢是垂直滾動，但 tab 列/選擇框這種只有橫向可捲動的
// 容器完全沒有反應，使用者會誤以為「滑不動」。這裡把垂直滾輪量轉成橫向捲動；
// 容器本身沒有橫向溢位、或使用者本來就在做水平滑動（deltaX 已經有值）時不轉換。
//
// 故意不呼叫 e.preventDefault()：React 的 onWheel 是掛在 passive listener 上，
// 呼叫了也擋不掉原生捲動，還會在 console 噴警告，索性讓頁面照樣垂直捲動，
// tab 列跟著橫向捲動即可，兩個手感同時發生不影響可用性。
export function scrollHorizontallyOnWheel(e) {
  const el = e.currentTarget;
  if (el.scrollWidth <= el.clientWidth) return;
  if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
  el.scrollLeft += e.deltaY;
}
